<div class="account-pages my-5 pt-sm-5">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Free Register</h5>
                  <p>Get your HESLB account now.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="assets/images/profile-img.png" alt="" class="img-fluid">
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <a routerLink="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="assets/images/logo.png" alt="" class="rounded-circle" height="34">
                  </span>
                </div>
              </a>
            </div>
            <div class="p-2">

              <form class="needs-validation" name="signupForm" [formGroup]="advancedSearchForm"
                    novalidate>
                <ng-container>
                  <div class="mb-3">
                    <label for="refNo" class="form-label">Advanced Search Reference Number</label>

                    <input type="text" formControlName="refNo" class="form-control"
                           (change)="onChangeRefNo(advancedSearchForm.value)"
                           [ngClass]="{ 'is-invalid': (f.refNo.dirty || f.refNo.touched) && f.refNo.errors }" id="refNo"
                           placeholder="Enter Your Advanced Search Reference Number" />
                    <div *ngIf="(f.refNo.dirty || f.refNo.touched) && f.refNo.errors" class="invalid-feedback">
                      <div *ngIf="f.refNo?.errors?.required">Reference Number is required</div>
                    </div>
                  </div>
                  <div class="table-responsive mt-1" *ngIf="savedAdvancedSearchDetails">
                    <table class="table table-striped table-hover mb-4">
                      <tbody>
                        <tr>
                          <td class="font-weight-bold">First Name</td>
                          <td class="font-weight-bold">{{savedAdvancedSearchDetails?.first_name}}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">Middle Name</td>
                          <td class="font-weight-bold">{{savedAdvancedSearchDetails?.middle_name | replaceNullWithText : '-' }}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">Last Name</td>
                          <td class="font-weight-bold">{{savedAdvancedSearchDetails?.last_name}}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">Gender</td>
                          <td class="font-weight-bold">{{savedAdvancedSearchDetails?.sex}}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">University Of Study</td>
                          <td class="font-weight-bold">{{savedAdvancedSearchDetails?.university_of_study}}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">University Start Year</td>
                          <td class="font-weight-bold">{{savedAdvancedSearchDetails?.university_start_year}}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">University Completion Year</td>
                          <td class="font-weight-bold">{{savedAdvancedSearchDetails?.university_completion_year}}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">Email</td>
                          <td class="font-weight-bold">{{savedAdvancedSearchDetails?.email}}</td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">Phone Number</td>
                          <td class="font-weight-bold">{{savedAdvancedSearchDetails?.phone_number}}</td>
                        </tr>
                        <ng-container *ngIf="savedAdvancedSearchDetails?.advanced_search_complete; else advancedSearchNotComplete">
                          <tr>
                            <td class="font-weight-bold">Advanced Search Status</td>
                            <td class="font-weight-bold text-success" >Completed</td>
                          </tr>
                          <ng-container *ngIf="savedAdvancedSearchDetails?.match_found; else noMatchIndexNo">
                            <tr>
                              <td class="font-weight-bold">Matching Index-No</td>
                              <td class="font-weight-bold text-success" >{{savedAdvancedSearchDetails?.match_index_no}}</td>
                            </tr>
                          </ng-container>
                          <ng-template #noMatchIndexNo>
                            <tr>
                              <td class="font-weight-bold text-warning text-center" [colSpan]="2">No Match For A Beneficiary Was Found Using The Details Provided</td>
                            </tr>
                          </ng-template>
                        </ng-container>
                        <ng-template #advancedSearchNotComplete>
                          <tr>
                            <td class="font-weight-bold">Advanced Search Status</td>
                            <td class="font-weight-bold text-warning" >In-Progress</td>
                          </tr>
                        </ng-template>
                      </tbody>
                    </table>
                  </div>

                </ng-container>
              </form>
            </div>
          </div>
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <p>Already have an account ? <a routerLink="/account/login" class="fw-medium text-primary"> Login</a>
          <p>© {{year}} HESLB.</p>
        </div>
      </div> <!-- end col -->
    </div>
    <!-- end row -->
  </div>
  <!-- end container -->
</div>
